import { render, staticRenderFns } from "./authenticationResult.vue?vue&type=template&id=1049805e&scoped=true&"
import script from "./authenticationResult.vue?vue&type=script&lang=js&"
export * from "./authenticationResult.vue?vue&type=script&lang=js&"
import style0 from "./authenticationResult.vue?vue&type=style&index=0&id=1049805e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1049805e",
  null
  
)

export default component.exports